export const de_DE = {
  // Header/Sidebar
  user: "Benutzer",
  users: "Benutzer",
  installations: "Installationen",
  settings: "Einstellungen",
  certificate: "Zertifikat",
  main_settings: "Hauptoptionen",
  terminology: "Begriffinologie",
  equipment: "Ausstattung",
  security: "Sicherheit",
  tenants: "Mieter",
  collapse: "Einklappen",
  branding: "Markenbildung",
  sign_out: "Abmelden",
  hello: "Hallo!",
  reports: "Berichte",

  // Misc
  save: "Speichern",
  cancel: "Abbrechen",

  // Installation Table
  status: "Status",
  clear: "Löschen",
  date: "Datum",
  technician: "Techniker",
  customer_phone: "Kundentelefon",
  address: "Adresse",
  unit: "Einheit",
  city: "Stadt",
  state_prov: "Bundesland/Provinz",
  rooms_tested: "Getestete Zimmer",
  tested: "Getestet",
  plan: "Abonnement",
  rows_per_page: "Zeilen pro Seite:",
  recommended_short: "Empfehlung.",
  notes: "Notizen",

  // Certificate Branding Tab
  current_image: "Aktuelles Bild: ",
  using_default_logo: "Verwenden des Standardlogos",
  new_image: "Neues Bild",
  branding_loading_error:
    "Fehler beim Laden der Marke. Bitte versuchen Sie es später noch einmal.",
  upload_new_image: "Neues Bild hochladen",
  clear_custom_image: "Benutzerdefiniertes Bild löschen",
  clear_custom_color: "Benutzerdefinierte Farbe löschen",
  brand_color: "Markenfarbe",
  header_message: "Überschriftennachricht",
  header_education_message: "Überschriftenbildungsnachricht",
  footer_education_message: "Fußzeilenbildungsnachricht",
  preview: "Vorschau",
  file_must_be_less_than_size_limit: "Die Datei muss kleiner als 30 KB sein",

  // Certificate Headers
  congrats_message:
    "Ihre WLAN-Installation ist abgeschlossen und wurde von RouteThis zertifiziert!",
  installation_details: "Installationsdetails",
  wireless_speed_test: "Geschwindigkeitstest für Drahtlosnetzwerk",
  wireless_speed_test_hidespeedtest: "Wi-Fi-Geschwindigkeitstest",
  wireless_performance: "Leistung des Drahtlosnetzwerks",
  photos: "Fotos",
  signal_maps: "Signal-Karten",
  wifi_information: "Verstehen der Wi-Fi-Geschwindigkeit",

  // Certificate Zimmer Names
  singular_room: "Room",
  room_type_bathroom: "Badezimmer",
  room_type_bedroom: "Schlafzimmer",
  room_type_dining_room: "Esszimmer",
  room_type_entry_or_hall: "Eingang/Flur",
  room_type_garage: "Garage",
  room_type_kitchen: "Küche",
  room_type_living_room: "Wohnzimmer",
  room_type_office: "Büro",
  room_type_other: "Andere",

  // Pod Name
  pod_1: "Mesh Pod",
  pod_2: "Zugangspunkt",
  pod_3: "Mesh-Knoten",
  pod_4: "Mesh Puck",
  pod_5: "Leuchtfeuer",
  pod_6: "Wi-Fi Repeater",
  pods_1: "Mesh Pods",
  pods_2: "Zugangspunkte",
  pods_3: "Mesh-Knoten",
  pods_4: "Mesh-Pucks",
  pods_5: "Leuchtfeuer",
  pods_6: "Wi-Fi Repeater",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Residential Gateway",

  // Ebene Name
  level_1: "Etage",
  level_2: "Etage",
  levels_1: "Etagen",
  levels_2: "Etagen",

  // a11y Labels
  go_to_homepage: "Zur Startseite gehen",
  edit_user_x: "Benutzer [X] bearbeiten",
  open_certificate_for_addr: "Zertifikat für [ADDR] öffnen",
  clear_all_filters: "alle Filter löschen",
  expand_sidebar: "Seitenleiste erweitern",
  current_tenant_branding_image: "Aktuelles Markenbild des Mieters",
  new_tenant_branding_image: "Neues Mieter Branding Bild",

  // Certificate Pod Info
  recommended: "Empfohlen",
  installed: "Installiert",
  installed_singular: "Installiert",
  total: "Gesamt",

  // Certificate Signal Table
  front_building: "Vorderseite des Gebäudes",
  speed: "Geschwindigkeit",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Häufigkeit",
  frequency_description: "MHz",
  channel_short: "Kanal",

  // Certificate Legende
  legend: "Legend",
  measured_speed: "Gemessene Geschwindigkeit",
  measured_speed_description: "Mbps",
  plan_speed: "Abonnement-Geschwindigkeit",

  // Certificate Speedtest Result
  speedtest_passed:
    "Die Geschwindigkeit liegt im erwarteten Bereich für die meisten mobilen Geräte. Nicht alle drahtlosen Geräte sind in der Lage, die maximale Plangeschwindigkeit zu erreichen. Siehe unten für einzelne Raumtests.",
  speedtest_passed_hidespeedtest:
    "Überprüfte Internetverbindungsgeschwindigkeit für Ihren Tarif.",
  speedtest_failed:
    "Getestet auf einem Telefon oder Tablet. Nicht alle drahtlosen Geräte sind in der Lage, die maximale Plangeschwindigkeit zu erreichen. Siehe unten für einzelne Raumtests.",
  speedtest_24ghz:
    "Der Geschwindigkeitstest wurde auf dem 2,4-GHz-Band durchgeführt; niedrige Geschwindigkeit aufgezeichnet.",
  speedtestmessages_strong:
    "Die Geschwindigkeit liegt im erwarteten Bereich für die meisten mobilen Geräte.",
  speedtestmessages_weak:
    "Die Geschwindigkeit liegt weit unter dem erwarteten Bereich für die meisten mobilen Geräte.",
  speedtestmessages_medium:
    "Die Geschwindigkeit liegt unter dem erwarteten Bereich für die meisten mobilen Geräte.",
  wifi_activities_highspeed_videos: "Mehrere 4K-Videos",
  wifi_activities_highspeed_conferencing: "Videokonferenzen",
  wifi_activities_highspeed_gaming: "Online-Spiele",
  wifi_activities_highspeed_music: "Musik-Streaming",
  wifi_activities_lowspeed_conferencing: "Videokonferenzen",
  wifi_activities_lowspeed_gaming: "Online-Gaming",
  wifi_activities_lowspeed_music: "Musik-Streaming",
  wifi_activities_lowspeed_email: "E-Mail & soziale Netzwerke",
  speedTestIndicatorText_weak: "Schlechte Wi-Fi-Geschwindigkeit",
  speedTestIndicatorText_medium: "Langsamere Wi-Fi-Geschwindigkeit",
  speedTestIndicatorText_strong: "Optimale Wi-Fi-Geschwindigkeit",
  signal_coverage: "Signalabdeckung",
  signaltablemessage_title:
    "Aktivitäten sind von links nach rechts nach erforderlicher Signalstärke geordnet.",
  signaltablemessage_subtitle:
    "Wenn Sie eine Aktivität im angegebenen Raum ausführen können, können Sie auch alle Aktivitäten rechts davon ausführen.",
  alerts: "Warnungen",
  alertMessages_bandAlert:
    "Der Speedtest wurde im 2,4-GHz-Band durchgeführt; niedrige Geschwindigkeit gemessen.",
  alertMessages_lowSignalAlert:
    "Ihre Verbindung hier ist stabil und erlaubt das Browsen in E-Mails und sozialen Medien, aber Sie werden nicht die volle Geschwindigkeit erleben, die in anderen Räumen Ihres Hauses verfügbar ist.",
  alertMessages_veryLowSignalAlert:
    "Ihr Signal ist sehr schwach. Sie können lange Ladezeiten und Unterbrechungen erleben. Bewegen Sie sich für eine bessere Erfahrung in einen Bereich mit stärkerem Signal.",
  alertMessages_noAlert: "Keine Warnungen auf dieser Etage",
  alertmessages_lowPodsAlert:
    "Da nicht alle empfohlenen Wi-Fi Repeater installiert wurden, kann die Geschwindigkeit sinken, je weiter Sie sich vom Router entfernen.",
  customLowPodsAlertString:
    "Da nicht alle empfohlenen %PODSNAME installiert wurden, kann die Geschwindigkeit sinken, je weiter Sie sich vom %ROUTERNAME entfernen.",

  // Reports Page
  reports_access_error:
    "Bitte kontaktieren Sie Ihren Administrator, um diese Seite zu sehen",

  // Login/Reset Passwort
  password: "Password",
  sign_in: "Anmelden",
  forgot_password: "Passwort vergessen",
  reset_password: "Passwort zurücksetzen",
  reset_password_instructions:
    "Um Ihr Passwort zurückzusetzen, geben Sie Ihre E-Mail-Adresse oben ein und wir senden Anweisungen, falls das Konto existiert.",
  sent_reset_password_code:
    "Wir haben einen Code zum Zurücksetzen des Passworts an [email] gesendet. Geben Sie diesen Code und ein neues Passwort ein.",
  reset_code: "Rücksetzcode",
  new_password: "Neues Passwort",
  reenter_new_password: "Neues Passwort erneut eingeben",
  must_include_email: "Muss E-Mail enthalten",
  old_password: "Altes Passwort",
  set_new_password: "Neues Passwort festlegen",
  password_expired: "Passwort abgelaufen",
  toggle_password_visibility: "Passwortsichtbarkeit umschalten",
  change_your_password: "Ändere dein Passwort",
  change_password: "Passwort ändern",
  set_password: "Passwort festlegen",

  // Users List
  new_user: "Neuer Benutzer",
  edit_user: "Benutzer bearbeiten",
  bulk_import: "Massenimport",
  bulk_import_users: "Benutzer im Bulk importieren",
  show_disabled_users: "Deaktivierte Benutzer anzeigen",
  name: "Name",
  role: "Rolle",
  roles: "Rollen",
  location: "Standort",
  group: "Gruppe",
  manager: "Manager",
  download_bulk_template: "Bulk-Vorlage herunterladen",
  user_id_email: "Benutzer-ID (E-Mail)",

  // Valid User roles
  user_role: "user",
  tenant_admin_role: "TenantAdmin",
  super_admin_role: "SuperAdmin",
  tenant_admin: "Mietverwalter",
  super_admin: "Super Verwalter",

  // Erstellen/Bearbeiten User Modal
  email_required: "E-Mail (Erforderlich)",
  first_name: "Vorname",
  last_name: "Nachname",
  force_password_reset: "Passwort-Zurücksetzung erzwingen",
  resend_validation_code: "Validierungscode erneut senden",
  enable_user: "Benutzer aktivieren",
  disable_user: "Benutzer deaktivieren",
  certify: "Zertifizieren",
  unverified: "Nicht verifiziert",
  locked_out: "Ausgesperrt",
  disabled: "Deaktiviert",
  reset_user_password_confirmation:
    "Sind Sie sicher, dass Sie das Passwort dieses Benutzers zurücksetzen möchten?",
  resend_validation_code_confirmation:
    "Sind Sie sicher, dass Sie den Validierungscode erneut senden möchten?",
  cannot_disable_yourself: "Sie können sich selbst nicht deaktivieren.",
  cancel_changes: "Änderungen abbrechen",

  // Snackbar Messages
  snackbar_disable_success: "Benutzer erfolgreich deaktiviert:",
  snackbar_disable_error: "Fehler beim Deaktivieren des Benutzers:",
  snackbar_enable_success: "Benutzer erfolgreich aktiviert:",
  snackbar_enable_error: "Fehler beim Aktivieren des Benutzers:",
  snackbar_password_reset_success:
    "Das Passwort für den Benutzer wurde erfolgreich zurückgesetzt:",
  snackbar_password_reset_error:
    "Fehler beim Zurücksetzen des Passworts für den Benutzer:",

  // Bulk Importieren Modal
  csv_format_requirements:
    "Ihr CSV Format muss ordnungsgemäß formatiert sein. Wenn Sie sich unsicher über das Format sind, können Sie auch",
  csv_format_download_link: "eine Vorlagendatei hier herunterladen.",

  csv_format_error:
    "Wir konnten Ihre hochgeladene Datei nicht verarbeiten, bitte stellen Sie sicher, dass Ihre Datei im korrekten Format vorliegt und die Überschriften 'email' und 'manager_0' enthält.",
  select_csv: "CSV-Datei durchsuchen",
  import: "Import",
  file_too_large: "Datei zu groß (Maximum IMPORT_LIMIT Nutzer)",
  required_headers_missing: "Erforderliche Kopfzeilen fehlen: E-Mail",
  user_import_starting:
    "Benutzerimport beginnt. Sie erhalten in wenigen Minuten eine Zusammenfassungs-E-Mail zum Import.",
  change_file: "Datei ändern",

  // Bulk Import Messaging
  bulk_processing_1: "Wir verarbeiten die Datei:",
  bulk_processing_2:
    "Sobald wir fertig sind, senden wir Ihnen eine E-Mail mit allen Details.",
  bulk_complete_1: "Abgeschlossen:",
  bulk_complete_2: "ist jetzt hochgeladen.",
  bulk_error:
    "Ein Fehler ist aufgetreten und Ihre Datei wurde nicht auf den Server hochgeladen. Bitte überprüfen Sie Ihre E-Mail auf Details.",
  bulk_thanks_header: "Vielen Dank für das Hochladen Ihrer Datei!",
  bulk_thanks_content:
    "Wir arbeiten gerade an der Verarbeitung, und sobald wir fertig sind, senden wir Ihnen eine E-Mail mit allen Details. Sie können auch in der App nach Updates zum Status Ihrer Datei suchen.",

  // Tenant Main Settings
  email_language: "E-Mail Sprache",
  country: "Land",
  description_optional: "Beschreibung (Optional)",
  units_feet_meters: "Einheiten (Füße, Meter)",
  certify_id: "ID bestätigen",
  resolve_id: "ID lösen",
  sms_settings: "SMS Einstellungen",
  udp_flood_settings: "Einstellungen für UDP-Flut",
  udp_flood_settings_absolute_ideal:
    "BESTANDEN, wenn die UDP-Flutgeschwindigkeit größer ist als (Mbps)",
  udp_flood_settings_absolute_minimum:
    "WARNUNG, wenn die UDP-Flutgeschwindigkeit größer ist als (Mbps)",
  udp_flood_settings_plan_multiple:
    "BESTANDEN, wenn die UDP-Flutgeschwindigkeit größer ist als (mal die geplante Geschwindigkeit/Maximalgeschwindigkeit)",
  udp_flood_settings_absolute_plan_percentage:
    "WARNUNG, wenn die UDP-Flutgeschwindigkeit größer ist als (% der geplanten Geschwindigkeit/Maximalgeschwindigkeit)",
  sms_from: "SMS von",
  sms_body: "SMS-Inhalt",
  default_sms_body:
    "Ihre WLAN-Installation ist abgeschlossen und wurde von [NAME] zertifiziert! \n Sehen Sie sich hier Ihr Zertifikat an: [LINK]",
  sms_body_helper_text:
    "Certify wird diese Nachricht an den Kunden senden. [LINK] wird durch einen Link zum Zertifikat ersetzt (erforderlich). [NAME] wird durch den Inhalt des Namensfeldes ersetzt (optional)",
  link_must_be_in_sms_body: "[LINK] muss im SMS-Inhalt enthalten sein.",
  update_successful: "Aktualisierung erfolgreich",
  creation_successful: "Erstellung erfolgreich",

  // Tenant Terminology Settings
  term: "Term",
  example_usage: "Beispielhafte Nutzung",
  customer_example_usage_1:
    "In Absprache mit dem Kunden, bestätigen Sie das ausgewählte Gebäude oder gehen Sie zurück, um die Adresse zu bearbeiten.",
  customer_example_usage_2:
    "In Absprache mit dem Abonnenten, bestätigen Sie das ausgewählte Gebäude oder gehen Sie zurück, um die Adresse zu bearbeiten.",
  router_example_usage_1:
    "Tippen Sie auf den vorgeschlagenen Standort des Routers unten.",
  router_example_usage_2:
    "Tippen Sie auf den vorgeschlagenen Standort des Modems unten.",
  router_example_usage_3:
    "Tippen Sie auf den vorgeschlagenen Standort des Gateways unten.",
  router_example_usage_4:
    "Tippen Sie auf den vorgeschlagenen Standort des Hubs unten.",
  router_example_usage_5:
    "Tippen Sie auf den vorgeschlagenen Standort des Wohnnetzwerkgateways unten.",
  level_example_usage_1:
    "Gehen Sie zur Ebene 2 und tippen Sie auf Ihren Standort.",
  level_example_usage_2:
    "Gehen Sie zum Stockwerk 2 und tippen Sie auf Ihren Standort.",
  mesh_pod_example_usage_1:
    "Schätzung der Signalstärke und optimale Positionierung des Mesh-Pods.",
  mesh_pod_example_usage_2:
    "Schätzung der Signalstärke und optimale Positionierung des Zugriffspunkts.",
  mesh_pod_example_usage_3:
    "Schätzung der Signalstärke und optimale Positionierung des Mesh-Knotens.",
  mesh_pod_example_usage_4:
    "Schätzung der Signalstärke und optimale Positionierung des Mesh-Pucks.",
  mesh_pod_example_usage_5:
    "Schätzung der Signalstärke und optimale Positionierung des Beacons.",
  mesh_pod_example_usage_6:
    "Schätzung der Signalstärke und optimale Positionierung des Wi-Fi Repeaters.",
  wifi_example_usage_1: "WiFi-Kartierung",
  wifi_example_usage_2: "Wi-Fi Kartierung",
  wifi_example_usage_3: "Wifi Kartierung",
  wifi_example_usage_4: "WIFI Kartierung",

  // Tenant Equipment Settings (Certify)
  router_options_1: "Router Optionen",
  router_options_2: "Modem Optionen",
  router_options_3: "Gateway Optionen",
  router_options_4: "Hub Optionen",
  router_options_5: "Residential Gateway Optionen",
  new_router_options_1: "Neue Router Optionen",
  new_router_options_2: "Neue Modem Optionen",
  new_router_options_3: "Neue Gateway-Optionen",
  new_router_options_4: "Neue Hub-Optionen",
  new_router_options_5: "Neue Residential Gateway-Optionen",
  mesh_pod_options_1: "Mesh Pod-Optionen",
  mesh_pod_options_2: "Zugriffspunkt-Optionen",
  mesh_pod_options_3: "Mesh-Knotenoptionen",
  mesh_pod_options_4: "Mesh-Puck-Optionen",
  mesh_pod_options_5: "Beacon-Optionen",
  mesh_pod_options_6: "Reichweiten-Extender-Optionen",
  new_mesh_pod_options_1: "Neue Mesh Pod-Optionen",
  new_mesh_pod_options_2: "Neue Zugangspunkt-Optionen",
  new_mesh_pod_options_3: "Neue Mesh-Knoten-Optionen",
  new_mesh_pod_options_4: "Neue Mesh-Puck-Optionen",
  new_mesh_pod_options_5: "Neue Beacon-Optionen",
  new_mesh_pod_options_6: "Neue Reichweiten-Extender-Optionen",
  missing_required_router_info_1: "Fehlende notwendige Router-Informationen",
  missing_required_router_info_2: "Fehlende notwendige Modem-Informationen",
  missing_required_router_info_3: "Fehlende notwendige Gateway-Informationen",
  missing_required_router_info_4: "Fehlende notwendige Hub-Informationen",
  missing_required_router_info_5:
    "Fehlende notwendige Informationen zum Wohnungsnetzwerkgateway",
  missing_required_mesh_pod_info_1:
    "Erforderliche Mesh-Pod-Informationen fehlen",
  missing_required_mesh_pod_info_2:
    "Erforderliche Access-Point-Informationen fehlen",
  missing_required_mesh_pod_info_3:
    "Erforderliche Mesh-Knoten-Informationen fehlen",
  missing_required_mesh_pod_info_4:
    "Erforderliche Mesh-Puck-Informationen fehlen",
  missing_required_mesh_pod_info_5: "Erforderliche Beacon-Informationen fehlen",
  missing_required_mesh_pod_info_6:
    "Erforderliche Range-Extender-Informationen fehlen",
  display_name: "Anzeigename",
  description: "Beschreibung",
  range_in_unit_1: "Reichweite in Fuß",
  range_in_unit_2: "Reichweite in Metern",
  area_in_unit_1: "Fläche in Quadratfuß",
  area_in_unit_2: "Fläche in Quadratmetern",
  default_active: "Standard aktiv",
  average_range: "Durchschnittliche Reichweite",
  certify_default: "Standard zertifizieren",
  default: "Standard",
  active: "Aktiv",
  one_option_must_be_default: "Eine Option muss Standard sein",
  set_as_default: "Als Standard festlegen",
  default_option_must_be_active: "Standardoption muss aktiv sein",
  deactivate: "Deaktivieren",
  activate: "Aktivieren",
  name_is_required: "Name ist erforderlich",

  // Kunde Name
  customer_1: "Customer",
  customer_2: "Abonnent",
  // Wifi Name
  wifi_1: "WiFi",
  wifi_2: "Wi-Fi",
  wifi_3: "Wifi",
  wifi_4: "WIFI",

  // Einheiten
  units_1: "Füße",
  units_2: "Meter",

  // Misc
  confirm: "Bestätigen",
  units: "Units",
  region: "Region",
  edit: "Edit",
  modified: "Geändert",
  create: "Create",
  created: "Erstellt",
  routethis_app: "RouteDiese App",
  loading: "Wird geladen...",
  redirecting: "Weiterleiten...",
  error: "Fehler",
  close: "Schließen",
  search: "Suchen",
  all: "Alle",
  dismiss: "Verwerfen",

  // Languages
  en: "Englisch (US)",
  "en-GB": "Englisch (GB)",
  da: "Dänisch",
  fi: "Finnisch",
  fr: "Französisch",
  "fr-CA": "Französisch (Kanada)",
  de: "Deutsch",
  el: "Griechisch",
  it: "Italienisch",
  pt: "Portugiesisch",
  "pt-BR": "Portugiesisch (Brasilien)",
  es: "Spanisch",
  "es-419": "Spanisch (Lateinamerika)",
  sv: "Schwedisch",
};

export const en_errors = {
  // Client-side validation errors
  incorrect_email_or_password:
    "Ungültige E-Mail oder Passwort, oder deaktiviertes Konto. Versuchen Sie es erneut oder kontaktieren Sie einen Administrator.",
  invalid_reset_code: "Ungültiger Reset-Code",
  password_minimum_requirements:
    "Ihr Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer enthalten.",
  passwords_must_match: "Passwörter müssen übereinstimmen",
  must_include_new_password_email:
    "Muss neue Passwort und Benutzer-E-Mail enthalten",
  must_include_new_password_confirmation_code:
    "Muss neues Passwort und Bestätigungscode enthalten",
  cannot_send_reset_code_without_email:
    "Kann ohne E-Mail keinen Zurücksetzungscode senden",
  must_enter_old_password: "Altes Passwort muss eingeben werden",
  must_enter_reset_code: "Zurücksetzungscode muss eingeben werden",
  must_enter_new_password: "Neues Passwort muss eingeben werden",
  passwords_cannot_begin_or_end_with_spaces:
    "Passwörter dürfen nicht mit Leerzeichen beginnen oder enden",

  // Server-side errors
  "Ein Benutzer mit dieser E-Mail existiert bereits":
    "Ein Benutzer mit dieser E-Mail existiert bereits",
  "Versuchen Sie einen anderen Anzeigenamen":
    "Versuchen Sie einen anderen Anzeigenamen",
  "Passwort darf kein zuvor verwendetes Passwort sein":
    "Passwort darf kein zuvor verwendetes Passwort sein",
  "Ungültiger Rücksetzcode": "Ungültiger Rücksetzcode",
  "Ungültige E-Mail oder Passwort, oder deaktivierter Account. Versuchen Sie es erneut oder kontaktieren Sie einen Administrator.":
    "Ungültige E-Mail oder Passwort, oder deaktivierter Account. Versuchen Sie es erneut oder kontaktieren Sie einen Administrator.",
  "Ungültiger Code bereitgestellt, bitte fordern Sie einen Code erneut an.":
    "Ungültiger Code bereitgestellt, bitte fordern Sie einen Code erneut an.",
  "Passwort darf nicht mit Leerzeichen beginnen oder enden":
    "Passwort darf nicht mit Leerzeichen beginnen oder enden",
  "LimitExceededException - Versuchslimit überschritten, bitte versuchen Sie es nach einiger Zeit erneut.":
    "LimitExceededException - Versuchslimit überschritten, bitte versuchen Sie es nach einiger Zeit erneut.",
  "Benutzer ist nicht autorisiert": "Benutzer ist nicht autorisiert",
  "Ihre Sitzung ist abgelaufen. Melden Sie sich erneut mit Ihrem temporären Passwort an.":
    "Ihre Sitzung ist abgelaufen. Melden Sie sich erneut mit Ihrem temporären Passwort an.",
  "Interner Servicefehler - Cognito nicht verfügbar":
    "Interner Servicefehler - Cognito nicht verfügbar",
  "Interner Servicefehler - Unbekannter Fehler":
    "Interner Servicefehler - Unbekannter Fehler",
  "Muss Reset-Code eingeben": "Reset-Code muss eingegeben werden",

  // Change Password Challenges
  set_password_challenge:
    "Aus Sicherheitsgründen müssen Sie bei der ersten Anmeldung ein neues Passwort festlegen.",
  reset_password_challenge:
    "Wir haben einen Passwort-Reset-Code an [EMAIL] gesendet. Geben Sie diesen Code und ein neues Passwort ein.",
  set_new_password_challenge:
    "Die Richtlinien Ihrer Firma sehen vor, dass Ihr Passwort nach einiger Zeit abläuft. Wir haben einen Passwort-Reset-Code an [EMAIL] gesendet. Geben Sie diesen Code und ein neues Passwort ein.",
  change_your_password_challenge:
    "Geben Sie unten Ihr aktuelles Passwort und ein neues Passwort ein, um es zu ändern.",
  change_password_challenge:
    "Geben Sie ein neues Passwort für den Benutzer ein",
};

export const en_countries = {
  AF: "Afghanistan",
  AX: "Åland Inseln",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Österreich",
  AZ: "Aserbaidschan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien (Plurinationaler Staat von)",
  BQ: "Bonaire, Sint Eustatius und Saba",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Kap Verde",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  KY: "Kaimaninseln",
  CF: "Zentralafrikanische Republik",
  TD: "Tschad",
  CL: "Chile",
  CN: "China",
  CX: "Weihnachtsinsel",
  CC: "Kokosinseln (Keeling)",
  CO: "Kolumbien",
  KM: "Komoren",
  CG: "Kongo",
  CD: "Kongo, Demokratische Republik des",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Kroatien",
  CU: "Kuba",
  CW: "Curaçao",
  CY: "Zypern",
  CZ: "Tschechien",
  DK: "Dänemark",
  DJ: "Dschibuti",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  EC: "Ecuador",
  EG: "Ägypten",
  SV: "El Salvador",
  GQ: "Äquatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  SZ: "Eswatini",
  ET: "Äthiopien",
  FK: "Falklandinseln (Malvinas)",
  FO: "Färöer-Inseln",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Süd- und Antarktisgebiete",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Deutschland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griechenland",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-Insel und McDonald-Inseln ",
  VA: "Heiliger Stuhl",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran (Islamische Republik)",
  IQ: "Irak",
  IE: "Irland",
  IM: "Insel Man",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanien ",
  KZ: "Kasachstan ",
  KE: "Kenia ",
  KI: "Kiribati ",
  KP: "Korea (Demokratische Volksrepublik) ",
  KR: "Republik Korea ",
  KW: "Kuwait ",
  KG: "Kirgisistan ",
  LA: "Demokratische Volksrepublik Laos ",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallinseln",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  FM: "Mikronesien (Föderierte Staaten von)",
  MD: "Moldau, Republik",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Niederlande",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkinsel",
  MK: "Nordmazedonien",
  MP: "Nördliche Marianen",
  NO: "Norwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palästina, Staat von",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumänien",
  RU: "Russische Föderation",
  RW: "Ruanda",
  BL: "Saint Barthélemy",
  SH: "St. Helena, Ascension und Tristan da Cunha",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  MF: "Saint Martin (französischer Teil)",
  PM: "Saint-Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten (niederländischer Teil)",
  SK: "Slowakei",
  SI: "Slowenien",
  SB: "Salomonen",
  SO: "Somalia",
  ZA: "Südafrika",
  GS: "Südgeorgien und die Südlichen Sandwichinseln",
  SS: "Südsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SE: "Schweden",
  CH: "Schweiz",
  SY: "Syrische Arabische Republik",
  TW: "Taiwan, Provinz China",
  TJ: "Tadschikistan",
  TZ: "Tansania, Vereinigte Republik",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Vereinigte Arabische Emirate",
  GB: "Vereinigtes Königreich von Großbritannien und Nordirland",
  US: "Vereinigte Staaten von Amerika",
  UM: "Amerikanisch-Ozeanien",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarische Republik)",
  VN: "Vietnam",
  VG: "Britische Jungferninseln",
  VI: "Amerikanische Jungferninseln",
  WF: "Wallis und Futuna",
  EH: "Westsahara",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Simbabwe",
};
